import { render, staticRenderFns } from "./ModalActiver.vue?vue&type=template&id=66191d7a&scoped=true&"
import script from "./ModalActiver.vue?vue&type=script&lang=js&"
export * from "./ModalActiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66191d7a",
  null
  
)

export default component.exports